var _a;
// Types
import { Sizes } from '../../../common/types/Sizes';
export var ParagraphStylePropertiesBySize = (_a = {},
    _a[Sizes.LARGE] = {
        fontSize: '16px',
        letterSpacing: '-0.24px',
    },
    _a[Sizes.MEDIUM] = {
        fontSize: '14px',
        letterSpacing: '-0.24px',
    },
    _a[Sizes.SMALL] = {
        fontSize: '12px',
        letterSpacing: '-0.16px',
    },
    /**
     * @deprecated Added to allow for a more seamless transition from ParagraphXSmall
     */
    _a[Sizes.X_SMALL] = {
        fontSize: '10px',
        letterSpacing: '-0.16px',
    },
    _a);
//# sourceMappingURL=ParagraphStylePropertiesBySize.js.map